import './Blogs.css'
import { useState, useMemo } from 'react'

const STEP = 3

const Blogs = ({ blogs = [] }) => {
  const safeBlogs = Array.isArray(blogs) ? blogs : []
  const [visibleBlogs, setVisibleBlogs] = useState(STEP)

  const items = useMemo(
    () =>
      safeBlogs.map((b, i) => ({
        // sensible fallbacks so UI never breaks
        title: b?.title || `Untitled Post ${i + 1}`,
        link: b?.link || '#',
        image: b?.image || '',
        date: b?.date || '',
        description: b?.description || '',
        key: b?.link || b?.title || `blog-${i}`,
      })),
    [safeBlogs]
  )

  const loadMoreBlogs = () => setVisibleBlogs((n) => n + STEP)

  if (items.length === 0) return null

  return (
    <div className='about__details'>
      <section className='section blogs' aria-labelledby='blogs-title'>
        <h2 id='blogs-title' className='section__title'>
          Featured Blogs
        </h2>

        <ul className='blogs__list'>
          {items.slice(0, visibleBlogs).map((blog, idx) => (
            <li
              key={blog.key}
              className='blog__item'
              style={{ '--i': idx }} // for staggered animation
            >
              <div className='blog__image-container'>
                {blog.image ? (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className='blog__image'
                    loading='lazy'
                    decoding='async'
                  />
                ) : (
                  <div
                    className='blog__image blog__image--placeholder'
                    aria-hidden='true'
                  />
                )}
              </div>

              <div className='blog__content'>
                {blog.link && blog.link !== '#' ? (
                  <a
                    href={blog.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='blog__title'
                    aria-label={`${blog.title} (opens in new tab)`}
                  >
                    {blog.title}
                  </a>
                ) : (
                  <span className='blog__title blog__title--nolink'>
                    {blog.title}
                  </span>
                )}

                {blog.date && <p className='blog__date'>{blog.date}</p>}
                {blog.description && (
                  <p className='blog__description'>{blog.description}</p>
                )}
              </div>
            </li>
          ))}
        </ul>

        {visibleBlogs < items.length && (
          <button
            type='button'
            className='load-more-btn'
            onClick={loadMoreBlogs}
            aria-label='Load more blog posts'
          >
            Load More
          </button>
        )}
      </section>
    </div>
  )
}

export default Blogs
